// src/api/guiasApi.js
//
// Administración de Guías desde el panel Superadmin HolaVeci web.
// Endpoints protegidos con rol SUPERADMIN.

import { api, API_BASE_URL, tokenStorage } from './apiClient';

const BASE = '/api/pos/admin-plataforma/guias';

export const guias = {
  listar: (filtros = {}) =>
    api.get(BASE, { query: filtros }),

  obtener: (id) =>
    api.get(`${BASE}/${id}`),

  /**
   * Crear un Guía. Si el punto base cae dentro de una zona donde ya
   * hay 3+ Guías activos en radio de 2km, el backend responde 409.
   * Pasar { forzar: true } para saltarse la validación de densidad.
   */
  crear: (dto, { forzar = false } = {}) =>
    api.post(BASE, dto, { query: { forzar } }),

  actualizar: (id, dto) =>
    api.put(`${BASE}/${id}`, dto),

  cambiarEstado: (id, estado, motivo = null) =>
    api.patch(`${BASE}/${id}/estado`, { estado, motivo }),

  /**
   * Sube el certificado bancario. Backend multipart/form-data 'archivo'.
   * Al subir uno nuevo se reinicia la verificación (queda pendiente).
   */
  subirCertificadoBancario: async (id, file) => {
    const fd = new FormData();
    fd.append('archivo', file);
    const r = await fetch(`${API_BASE_URL}${BASE}/${id}/certificado-bancario`, {
      method: 'POST',
      body: fd,
      headers: { Authorization: `Bearer ${tokenStorage.get()}` },
    });
    if (!r.ok) {
      const txt = await r.text().catch(() => '');
      throw new Error(txt || 'No se pudo subir el certificado.');
    }
    return r.json();
  },

  verificarCertificado: (id, verificado) =>
    api.patch(`${BASE}/${id}/certificado-bancario/verificar`, { verificado }),

  // ── Supervisión: acceso read-only del admin a la vista completa del guía ──
  supervision: {
    panel:         (id)                => api.get(`${BASE}/${id}/supervision/panel`),
    afiliados:     (id)                => api.get(`${BASE}/${id}/supervision/afiliados`),
    comisiones:    (id, filtros = {})  => api.get(`${BASE}/${id}/supervision/comisiones`, { query: filtros }),
    liquidaciones: (id)                => api.get(`${BASE}/${id}/supervision/liquidaciones`),
    detalleLiquidacion: (id, liqId)    => api.get(`${BASE}/${id}/supervision/liquidaciones/${liqId}`),
  },
};
